import type { TDocumentoAnexado, TDocumentosPessoa } from '../types'

export const selectRecuperarDocumentos = (data: TDocumentosPessoa): TDocumentoAnexado[] =>
  data?.documentos?.map((documento) => ({
    id: `${documento.dataEnvio}-${documento.tipo}`,
    status: 'recovered',
    tipo: documento.tipo,
  })) || []
